import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { createContext, useContext } from "react";

/**
 * Create a side-effect-free context provider so blocker can be handled independent from Mobx.
 * Mobx is not enqueued in website frontend for bundle-size purposes!
 */
var BlockerContextFactory = /*#__PURE__*/function () {
  function BlockerContextFactory() {
    _classCallCheck(this, BlockerContextFactory);
  }

  _createClass(BlockerContextFactory, null, [{
    key: "Context",
    value: function (_Context) {
      function Context() {
        return _Context.apply(this, arguments);
      }

      Context.toString = function () {
        return _Context.toString();
      };

      return Context;
    }(function () {
      return this.context = this.context || /*#__PURE__*/createContext({});
    })
  }]);

  return BlockerContextFactory;
}();

BlockerContextFactory.context = void 0;

function useBlocker() {
  return useContext(BlockerContextFactory.Context());
}

export { BlockerContextFactory, useBlocker };